<template>
  <div class="login fixed-nav">
    <MainHeader
      :dark="false"
      :fixedMenu="true"
      :loginButton="true"
      :tiles="false"
      @logoClick="logoClick"
    >
      <svg>
        <use v-if="selectedTranslation === 'en'" xlink:href="#logoWmkSvgEng"></use>
        <use v-else xlink:href="#logoWmkSvg"></use>
      </svg>
    </MainHeader>
    <div class="sections">
      <section class="section-form section-main">
        <RegisterForm />
      </section>
      <MainFooter
        key="footer"
        :content="footerData"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import RegisterForm from '@/components/RegisterForm.vue'
import MainHeader from '@/components/MainHeader.vue'
import MainFooter from '@/components/MainFooter.vue'

export default {
  name: 'register',
  components: {
    RegisterForm,
    MainHeader,
    MainFooter
  },
  methods: {
    ...mapActions([
      'resetActiveFilters',
      'setNotRegistered'
    ]),
    logoClick () {
      this.$router.push({ 'name': 'virtual' })
    }
  },
  computed: {
    ...mapGetters([
      'isLoggedIn',
      'footerData',
      'selectedTranslation'
    ])
  },
  mounted () {
    this.resetActiveFilters()

    /**
     * Returns to the previous page or menu when user is logged in.
     */
    if (this.isLoggedIn) {
      if (this.$store.state.route && this.$store.state.route.from && this.$store.state.route.from.fullPath) {
        if (this.$store.state.route.from.fullPath !== '/login') {
          this.$router.push({ 'path': this.$store.state.route.from.fullPath })
        } else {
          this.$router.push({ 'name': 'menu' })
        }
      } else {
        this.$router.push({ 'name': 'menu' })
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    this.setNotRegistered()
    next()
  }
}
</script>

<style scoped lang="scss">
</style>
